module.exports = __webpack_public_path__ + "static/img/05.0b4bba3a.png";